import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhoneAlt, FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";
import "./Footer.css";
import logo from "../../img/logo2.png"

export default function Footer() {
  return (
    <footer>
      <div className="footer-container">
        
        {/* Coluna 1 */}
        <div className="info" >
          <img src={logo} alt="Logo" className="footer-logo" />
          <p style={{color:"#fff"}}>Centralidade do Kilamba</p>
          <p style={{color:"#fff"}}>Quarteirão F, edifício F27</p>
          <p style={{color:"#fff"}}>apartamento 91 Kilamba</p>
          <p >Luanda - Angola</p>
          <p>
            <FaEnvelope className="contact-icons" /> geral@nwayami.com
          </p>
          <p>
            <FaPhoneAlt className="contact-icons" /> (+244) 972 614 886 / 921 909 103
          </p>
        </div>

        {/* Coluna 2 */}
        <div>
          <h4>INFORMAÇÕES</h4>
          <ul className="footer-category-list">
            
            <li><Link to="/politicas">Politicas e privacidade</Link></li>
            <li>
  <a href="https://www.nwayami.com" target="_blank" rel="noopener noreferrer">
    Prestação de serviços
  </a>
</li>
            <Link to="/contacto">Contactos</Link>
          </ul>
          <div className="social-media-container">
            <a href="#"><FaInstagram /></a>
            <a href="https://www.facebook.com/n.wayamistore" target="_blank" rel="noopener noreferrer"> <FaFacebook /></a>
            <a href="#"><FaLinkedin /></a>
          </div>
        </div>

        {/* Coluna 3 */}
        <div>
          <h4>CATEGORIAS</h4>
          <ul className="footer-category-list">
            <li>
              <Link to="/category/informatica">Informática</Link> |{" "}
              <Link to="/category/Impressão">Impressão</Link>
            </li>
            <li>
              <Link to="/category/redes-internet">Redes, Internet e Telecomunicações</Link>
            </li>
            <li>
              <Link to="/category/Energia">Energia</Link> |{" "}
              <Link to="/category/seguranca-eletronica">Segurança Electrónica</Link>
            </li>
            <li>
              <Link to="/category/Smartphones, Tablets e Telemóveis">
                Smartphones, Tablets e Telemóveis
              </Link>
            </li>
            <li>
              <Link to="/category/imagem-e-som">Imagem e Som</Link>
            </li>
            <li>
              <Link to="/category/eletrodomesticos">Electrodomésticos</Link> |{" "}
              <Link to="/category/Software">Software</Link>
            </li>
            <li>
              <Link to="/category/material-de-escritorio">
                Material de Escritório e Escolar
              </Link>
            </li>
          </ul>
        </div>

        {/* Coluna 4 */}
        <div className="info">
          <h4>CONTACTOS COMERCIAIS</h4>
          <p>(+244) 921 793 774</p>
          <p>geral@nwayami.com</p>

          <h4>CONTACTOS ASSISTÊNCIA TÉCNICA</h4>
          <p>(+244) 921 791 707 / 921 902 078</p>
          <p>suporte@nwayami.com</p>

          <h4>HORÁRIO DE ATENDIMENTO</h4>
          <p>Segunda - Sexta</p>
          <p>08:00h - 17:00h</p>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Nwayami. Todos os direitos reservados.
      </div>
    </footer>
  );
}
